import { render, staticRenderFns } from "./AvatarWithTitleAndAction2.vue?vue&type=template&id=fb69777e&"
import script from "./AvatarWithTitleAndAction2.vue?vue&type=script&lang=js&"
export * from "./AvatarWithTitleAndAction2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports